import { NetworkAssessmentAnalysisType, ProjectRunConfigurationType } from "@app/projects/enumerators";
import { ProjectRouteParams } from "@app/projects/projectRouteParams";
import { AccuracyNetworkProvidersPanel } from "@app/projects/servicing-provider";
import { AccuracyTemplateContext } from "@app/templates";
import * as H from "history";
import { JSX, useEffect } from "react";

export interface AccuracyInspectionDetailsProps {
  exportEndpoint: string;
  inspectionBand:string;
  inspectionUid: string;
  location: H.Location<ProjectRouteParams>;
  networkAssessmentAnalysisType: NetworkAssessmentAnalysisType;
  projectURL: string;
  setDualMembershipMode: (isDualMembershipMode: boolean, projectRunConfigurationType?: ProjectRunConfigurationType, primaryConfigurationId?: number, compareToRunConfigurationId?: number, forceLoading?: boolean) => void;
}

function AccuracyInspectionDetails({ exportEndpoint, inspectionUid, location, networkAssessmentAnalysisType, projectURL, setDualMembershipMode, inspectionBand }: AccuracyInspectionDetailsProps): JSX.Element {

  useEffect(() => {
    if (location.state && location.state.runConfiguration) {
      const config = location.state.runConfiguration;
      const compareToConfig = location.state.compareToRunConfiguration;
      setDualMembershipMode(location.state.isDualMembershipMode, config.projectRunConfigurationType, config.projectRunConfigurationId, compareToConfig ? compareToConfig.projectRunConfigurationId : undefined);
    }
  }, []);

  return (
    <AccuracyTemplateContext.Consumer>
      {(accuracyTemplate) => (
        <AccuracyNetworkProvidersPanel
          accuracyTemplate={accuracyTemplate}
          exportEndpoint={exportEndpoint}
          inspectionBand={inspectionBand}
          inspectionUid={inspectionUid}
          networkAssessmentAnalysisType={networkAssessmentAnalysisType}
          projectURL={projectURL}
        />
      )}
    </AccuracyTemplateContext.Consumer>

  );
}

export { AccuracyInspectionDetails };
